import { HANDBOOK_TYPE } from 'constants/handbooks';

export const CLICK_TO_BUY = {
    SEHP: {
        TITLE: 'Select a Handbook Type',
        SUB_TITLE: 'What type of handbook do you want to build for ${companyName}?',
        EMPLOYEE_COUNT: {
            MIN_LIMIT: 0,
            MAX_LIMIT: 1000,
        },
        SEH_PLUS_SKU_KEYS: [
            'handbooks.spanish',
            'handbookslocalpolicies',
            'handbooksmultistate',
            'esignature',
        ],
        SEH_PLUS_MUST_HAVE_SKU_KEYS: ['handbooks'],
        SEH_PLUS_MAY_HAVE_SKU_KEYS: ['handbooksfederal', 'handbooksonestate'],
        SEH_SKU_LIST: {
            [HANDBOOK_TYPE.ONE_STATE]: [
                {
                    id: 1,
                    name: 'Federal Compliance',
                },
                {
                    id: 2,
                    name: 'Compliance for One State',
                },
                {
                    id: 3,
                    name: 'Manage Employee E-Signatures',
                },
                {
                    id: 4,
                    name: 'Spanish Translation',
                },
                {
                    id: 5,
                    name: 'Select Local Policies',
                },
            ],
            [HANDBOOK_TYPE.MULTI_STATE]: [
                {
                    id: 1,
                    name: 'Federal Compliance',
                },
                {
                    id: 2,
                    name: 'Multi-State Compliance',
                },
                {
                    id: 3,
                    name: 'Manage Employee E-Signatures',
                },
                {
                    id: 4,
                    name: 'Spanish Translation',
                },
                {
                    id: 5,
                    name: 'Select Local Policies',
                },
            ],
        },
        BASIC_HANDBOOK: {
            TITLE: 'Single-State Handbook',
            DISCLAIMER_TEXT: 'Build a handbook for your company and one state.',
            NOTE: 'No Additional Fee',
            PENDO_ID: 'IPFM-Proceed_with_Single-State',
        },
        SMART_HANDBOOK: {
            TITLE: 'Smart Employee Handbook Plus',
            DISCLAIMER_TEXT:
                'Build a handbook for your company and all states with at least one company location.',
            NOTE: '<b>Pricing is based on company size.</b>',
            PENDO_ID: 'IPFM-Proceed_with_Multi-State',
            QUOTE_KEY: 'MIN - SMAR - EHP - Click to Buy',
            TERMS_IN_MONTHS: 12,
        },
        VIDEO_PANEL: {
            TITLE: 'Making the Case for Smart Employee Handbook Plus',
            SUB_TITLE:
                '<a href="https://lp.trustmineral.com/mineral-smart-employee-handbook-plus-resources-page/"> View our resource page </a> to help convince your organization with talking points, testimonials, FAQs, and more.',
            LINK: 'https://play.goconsensus.com/uf0f599f1?autoplay',
            SCROLL_TO_TOP_TEXT: 'Compare Employee Handbook Options',
        },
        BUTTONS: {
            LEARN_MORE: 'Upgrade Now',
            SELECT_BASIC: 'Proceed with Single-State',
            CLOSE: 'Close',
            PROCEED: 'Proceed',
        },
        PAYMENT_CONFIRMATION: {
            TITLE: "We're Setting Up Your Upgrade...",
            SUCCESS_TITLE: 'Upgrade Complete!',
            WAITING_MESSAGE: 'Smart Employee Handbook Plus',
            DESCRIPTION_1:
                "We're working in the background to set up your system. This may take a few <br> moments.",
            DESCRIPTION_2: "We'll notify you when your Smart Employee Handbook Plus is ready.",
            DESCRIPTION_3:
                'In the meantime, here are some useful resources to help you get started.',
            DESCRIPTION_4:
                'Click the Create Multi-State Handbook button below to use the new <br> Smart Employee Handbook Plus feature.',
            SUB_TITLE: 'Quick Reference Guide',
            SUCCESS: {
                TITLE: 'Thank you for your purchase!',
                SUB_TITLE_1: 'Your confirmation number is #${invoiceID}.',
                SUB_TITLE_2: 'Your are now ready to create a Smart Employee Handbook.',
            },
            FAILURE: {
                TITLE: 'Something went wrong.',
                SUB_TITLE_1:
                    'Your payment has been processed, but we\'re experiencing a minor error. Our team has been notified and you\'ll receive confirmation when your access to Smart Employee Handbook Plus is ready. <b>To avoid duplicate charges, please do not submit any additional payments</b>.<br><br>Got questions or not seeing a confirmation email? Please contact Mineral Technical Support at <a href="mailto:support@trustmineral.com"> support@trustmineral.com.',
            },
            RETRY: {
                MAX_ATTEMPT: 5,
                MAX_TIMEOUT: 4000,
            },
            BUTTONS: {
                CONTINUE: 'Continue',
                SYSTEM_UPDATE: 'System Updating...',
                CREATE_MULTI_STATE: 'Create Multi-State Handbook',
                DOWNLOAD_LINK: 'Getting Started with Smart Employee Handbook',
            },
            DOWNLOAD_URL:
                'https://assets.ctfassets.net/548jxf0ptn0a/5Lxn0yhSdmRh9h1hDS1Qj0/1c15bab25fb1210fe622f5db9b2e1506/Handbooks_PLUS_Getting_Started_Client_220521.pdf',
        },
        SALESFORCE_C2B_PRODUCT_IDS: {
            ALPHA: '01t5a00000IFrEWAA1',
            DEV: '01t5a00000IFrEWAA1',
            PREPROD: '01t5a00000IFrEWAA1',
            PROD: '01t5a00000IFrEWAA1',
            QA: '01t5a00000IFrEWAA1',
        },
        LEADS_INFO: {
            AD_TYPE: 'ClickToBuy',
            OPTY_NAME: 'Smart Employee Handbook Plus',
            PENDO_ID: '',
            SOURCE: 'CreateHandbook',
        },
    },
    WHP: {
        EMPLOYEE_COUNT: {
            MIN_LIMIT: 0,
            MAX_LIMIT: 1000,
        },
        SECTION_1: {
            TITLE: 'Upgrade to Workplace Harassment Prevention',
            DESCRIPTION:
                'Expand your Learn course catalog with interactive, harassment prevention training for your workforce. Workplace Harassment Prevention includes <b>19 courses</b> with interactive, state-mandated topics to ensure compliance. Plus, all courses are added to Learn, making it easy to assign and manage employee training from a single place.',
        },
        SECTION_2: {
            TITLE: 'Why Workplace Harassment Prevention?',
            DESCRIPTION:
                "Even organizations with the strongest workplace culture can experience incidents of harassment. And the average harassment claim settled outside of court can run an organization anywhere from $75,000 to $125,000. That's why it's so important to take proactive steps against workplace harassment with employee training.",
            BENEFIT_LIST: [
                'Ensure compliance with state-mandated training courses - in CA, CT, DE, IL, ME, NY',
                'Offer training courses for managers and employees',
                'Build an inclusive workplace culture with Diversity, Equity, and Inclusion courses',
                'Easily assign courses and track completions',
                'Train employees in Spanish and English',
            ],
        },
        SECTION_3: {
            TITLE: 'Start Using Workplace Harassment Prevention',
            DESCRIPTION:
                'Protect your people - and your organization - with harassment prevention training.',
        },
        WHP_SKU_KEYS: ['learnpackagenysharassment'],
        WHP_MUST_HAVE_SKU_KEYS: ['training', 'learn.admin'],
        COMMON: {
            BUTTONS: {
                BACK: 'back',
                CLOSE: 'Close',
                GET_PRICING: 'Get Pricing',
                VIEW_COURSE_CATALOG: 'View Course Catalog',
            },
            NOTE: 'Pricing is based on company size. ',
            IMAGE_TAG: 'Mineral™',
        },
        PAYMENT_CONFIRMATION: {
            TITLE: "We're Setting Up Your Upgrade...",
            SUCCESS_TITLE: 'View Courses in Learn',
            WAITING_MESSAGE: 'Workplace Harassment Prevention',
            DESCRIPTION_1:
                "We're working in the background to set up your system. This may take a few <br> moments.",
            DESCRIPTION_2:
                "We'll notify you when your Workplace Harassment Prevention training courses are ready.",
            DESCRIPTION_3:
                'In the meantime, here are some useful resources to help you get started.',
            DESCRIPTION_4:
                'Click the button below to use the new <br> Workplace Harassment Prevention feature.',
            SUB_TITLE: '',
            SUCCESS: {
                TITLE: 'Thank you for your purchase!',
                SUB_TITLE_1: 'Your confirmation number is #${invoiceID}.',
                SUB_TITLE_2: 'Your are now ready to create a Workplace Harassment Prevention.',
            },
            FAILURE: {
                TITLE: 'Something went wrong.',
                SUB_TITLE_1:
                    'Your payment has been processed, but we\'re experiencing a minor error. Our team has been notified and you\'ll receive confirmation when your access to Workplace Harassment Prevention training courses are ready. <b>To avoid duplicate charges, please do not submit any additional payments</b>.<br><br>Got questions or not seeing a confirmation email? Please contact Mineral Technical Support at <a href="mailto:support@trustmineral.com"> support@trustmineral.com.',
            },
            RETRY: {
                MAX_ATTEMPT: 5,
                MAX_TIMEOUT: 4000,
            },
            BUTTONS: {
                CONTINUE: 'Continue',
                SYSTEM_UPDATE: 'System Updating...',
                CREATE_MULTI_STATE: 'View Workplace Harassment Prevention Courses',
                DOWNLOAD_LINK: 'Getting Started with Workplace Harassment Prevention',
            },
            DOWNLOAD_URL: 'https://apps.trustmineral.com/help-center/training',
        },
        VIDEO_PANEL: {
            LINK: 'https://play.goconsensus.com/s5c963df1',
        },
        WHP_UPGRADE: {
            QUOTE_KEY: 'MIN - WKPH - USA',
            TERMS_IN_MONTHS: 12,
        },
        SALESFORCE_WHP_PRODUCT_IDS: {
            ALPHA: '01t5a00000Hz2hAAAR',
            DEV: '01t5a00000Hz2hAAAR',
            PREPROD: '01t5a00000Hz2hAAAR',
            PROD: '01t5a00000Hz2hAAAR',
            QA: '01t5a00000Hz2hAAAR',
        },
        LEADS_INFO: {
            AD_TYPE: 'h-banner',
            OPTY_NAME: 'LearnBundle-1_MNL',
            PENDO_ID: '#submitGuide',
            SOURCE: 'Learn-Course-Catalog-Top',
        },
        BREADCRUMBS: {
            TRAINING_LABEL: 'Training',
            PAGE_LABEL: 'Upgrade to Workplace Harassment Prevention',
        },
        WHP_PAGES: {
            COMPARISON_PAGE: 'COMPARISON_PAGE',
            EMPLOYEE_COUNT_PAGE: 'EMPLOYEE_COUNT_PAGE',
            NONE: 'NONE',
            PRICING_PAGE: 'PRICING_PAGE',
            TESTIMONIAL_PAGE: 'TESTIMONIAL_PAGE',
        },
        MODAL: {
            PURCHASE_CONFIRMATION_DETAILS_MODAL: {
                TITLE: 'Newly Added: Workplace Harassment Prevention courses',
                DESCRIPTION_1: 'Click the ',
                DESCRIPTION_2: '"Harassment"',
                DESCRIPTION_3: 'icon',
                DESCRIPTION_4:
                    'to get started with your new Workplace Harassment Prevention catalog.',
                DESCRIPTION_5:
                    'Meet your harassment compliance requirements with 45 training courses, now available and ready to assign to employees in your Learn dashboard.',
                DESCRIPTION_6:
                    'Need a quick overview on what\'s included with Workplace Harassment Prevention? <a href="https://trustmineral.com/solutions/learn-course-catalogs/#whp">View the catalog here.</a>',
                GOT_IT: 'Got it',
                GOT_IT_1: 'Got it!',
            },
        },
    },
    GHRC: {
        GHRC_SKU_KEYS: ['consultativeservices'],
    },
    LEARN_CATALOGS: {
        LEARN_CATALOGS_SKU_KEYS: [
            'courses.communication',
            'courses.leadershipmanagement',
            'courses.cybersecurity',
            'courses.msftskills',
            'courses.healthwellness',
            'courses.deib',
            'learn.admin',
            'training',
        ],
        LEARN_CATALOGS_MUST_HAVE_SKU_KEYS: ['learn.admin', 'training'],
    },
    ANONYMOUS_REPORTING: {
        ANONYMOUS_REPORTING_SKU_KEYS: ['anonreporting'],
    },
    ACA: {
        ACA_SKU_KEYS: ['aca-reporting'],
    },
    COMMON: {
        TYPES: {
            SEH_PLUS: 'SEH_PLUS',
            WHP: 'WHP',
            GHRC: 'GHRC',
            LEARN_CATALOGS: 'LEARN_CATALOGS',
            ANONYMOUS_REPORTING: 'ANONYMOUS_REPORTING',
            ACA: 'ACA',
        },
        EMPLOYEE_COUNT_VERIFICATION: {
            TITLE: 'Please Verify Your Total Employee Count',
            SUB_NAV_TITLE: 'Employee Count Verification',
            INSTRUCTION_1: {
                SEH_PLUS:
                    'An accurate employee count is critical when generating a valid employee handbook. Our records indicate that you have ${totalEmpCountText}. Is this information correct?',
                WHP:
                    'Please provide an accurate total employee count to move forward with the Workplace Harassment Prevention upgrade. Our records indicate that you have ${totalEmpCountText}. Is this information correct?',
            },
            INSTRUCTION_2: 'Please enter the total number of employees at ${companyName}.',
            TEXT_FIELD: 'Total Employee Count',
            SUFFIX: {
                TOTAL_EMPLOYEE: 'total employee',
                EMPLOYEE: 'employee',
                STATE: 'state',
            },
            BUTTONS: {
                CANCEL: 'Cancel',
                VERIFY: 'Verify',
            },
            ERROR: '*Employee count must be between 1 - 500000',
            ZERO_EMPLOYEE_ERROR: '*Number of employees cannot be 0',
            ZERO_EMPLOYEE: 0,
            MAX_EMPLOYEE_COUNT: 500000,
        },
        CONFIRMATION_MODAL: {
            WARING_MESSAGE: 'Something Went Wrong',
            DESCRIPTION_1:
                "We're sorry, a system error has occurred while trying to verify your employee count. We've notified our team of the issue. A representative will contact you within 48 hours for any questions and to complete your upgrade.",
            DESCRIPTION_1_1:
                "We're sorry, a system error has occurred. We've notified our team of the issue. A representative will contact you within 48 hours for any questions and to complete your upgrade.",
            BUTTONS: {
                CLOSE: 'Close',
            },
        },
        PRICING_CONFIRMATION: {
            TITLE: {
                SEH_PLUS: 'Smart Employee Handbook Plus Pricing',
                WHP: 'Workplace Harassment Prevention Pricing',
            },
            UNKNOWN_PRICING: 'Pricing is based on company size.',
            INSTRUCTION_1: '$${pricing} for a ${termInMonths}-month license.',
            INSTRUCTION_2: 'Upgrade pricing is based on a company size of ${totalEmpCountText}.',
            SUFFIX: {
                EMPLOYEE: 'employee',
            },
            SUB_TITLE: {
                SEH_PLUS: 'Upgrade Includes:',
                WHP: 'With Workplace Harassment Prevention training, you can:',
            },
            BENEFIT_LIST: {
                SEH_PLUS: [
                    'Federal Compliance',
                    'Multi-State Compliance',
                    'Manage Employee E-Signatures',
                    'Spanish Translation',
                    'Select Local Policies',
                ],
                WHP: [
                    'Ensure compliance with state-mandated training courses - in CA, CT, DE, IL, ME, NY',
                    'Offer training courses for managers and employees',
                    'Build an inclusive workplace culture with Diversity, Equity, and Inclusion courses',
                    'Easily assign courses and track completions',
                    'Train employees in Spanish and English',
                ],
            },

            BUTTONS: {
                PROCEED_TO_CHECKOUT: 'Proceed to Checkout',
                CANCEL: 'Cancel',
            },
        },
        TESTIMONIAL_PAGE: {
            TITLE:
                'Please wait while we process your upgrade. This process may take up to a minute.',
            CONTENTS: {
                SEH_PLUS: [
                    {
                        ID: '1',
                        CONTENT:
                            '<p>"<b>Smart Handbook Employee Plus</b> is user-friendly and allows me to readily include my own customized policies as well as making modifications as needed."</p>',
                        NAME: 'Lynne M. Kelly, PHR',
                        DESIGNATION: 'Human Resources Manager, Mainely Tubs',
                    },
                    {
                        ID: '2',
                        CONTENT:
                            '<p>"The <b>Smart Employee Handbook</b> tool is best in class. Having Mineral feels like we have an HR expert in-house to answer our questions and keep our policies and handbooks up-to-date and in compliance."</p>',
                        NAME: 'Kitty Richardson',
                        DESIGNATION: 'Operations Manager, Texoma Health Foundation',
                    },
                    {
                        ID: '3',
                        CONTENT: `<p>"The <b>Smart Employee Handbook</b> builder is by far the best I\'ve seen for a Handbook tool, with easy to find answers, templates, forms, policies, and more."</p>`,
                        NAME: 'Marlo Saunders',
                        DESIGNATION: 'VP of Human Resources, Mayroad',
                    },
                    {
                        ID: '4',
                        CONTENT: `<P>"The <b>Smart Employee Handbook</b> builder in the platform is easy to use and manage. The regulations are constantly updated, so I have peace of mind knowing my handbook is accurate."</p>`,
                        NAME: 'Geraldine Flatt',
                        DESIGNATION: 'Director, Sonoma Creamery LLC',
                    },
                ],
                WHP: [
                    {
                        ID: '1',
                        CONTENT:
                            "<p>\"Whenever there's a requirement update in California, the <b>Workplace Harassment Prevention</b> courses are ready to address the updates, even before I'm aware there's a change to regulations.\"</p>",
                        NAME: 'Shannon Kirkman',
                        DESIGNATION: 'Director of Human Resources, ProSciento',
                    },
                    {
                        ID: '2',
                        CONTENT:
                            '<p>"By using <b>Workplace Harassment Prevention</b>, we\'ve been able to provide effective harassment and diversity training for employees, meet state training mandates, and reduce training costs. Mineral is so useful, I use it every day!"</p>',
                        NAME: 'Alice Barnhart',
                        DESIGNATION: 'HR Manager, WBE Traffic Control',
                    },
                    {
                        ID: '3',
                        CONTENT:
                            '<p>"Mineral is a huge resource. I really appreciate the state regulatory updates and compliance training tracking, reminders, and vast options of HR and workplace safety training available."</p>',
                        NAME: 'Heather Wollenburg',
                        DESIGNATION: 'Consultant, ERRG Inc.',
                    },
                ],
            },
            TIMEOUT_MS: 5000,
        },
    },
    MARKET_PLACE: {
        TITLE: 'Solution Shop',
        DESCRIPTION:
            'Mineral premium solutions are designed to empower you to tackle complex HR and compliance challenges.',
        PRODUCTS: {
            CORE: {
                TITLE: 'Mitratech Mineral Solutions',
                DESCRIPTION:
                    'Mineral premium solutions are designed to empower you to tackle complex HR and compliance challenges.',
                EMPTY_PRODUCT_BANNER:
                    'There are no Mitratech Mineral solutions to purchase at this time.',
                SEHP: {
                    TITLE: 'Smart Employee Handbook Plus',
                    DESCRIPTION:
                        'All the power of the Smart Employee Handbook, plus the enhanced ability to create a multi-state compliant handbook with select local policies, capture e-signatures, and apply Spanish translations to support your diverse workforce.',
                    BUTTON_TEXT: 'Learn More',
                    LICENSE_CODES: ['MIN - SMAR - EHP - Click to Buy'],
                },
                WHP: {
                    TITLE: 'Workplace Harassment Prevention',
                    DESCRIPTION:
                        'Meet harassment requirements with an expanded Learn Catalog to ensure compliance. Each e-learning course includes interactive state-mandated topics to ensure compliance as well as Diversity, Equity and Inclusion training.',
                    BUTTON_TEXT: 'Learn More',
                    LICENSE_CODES: ['MIN - WKPH - USA'],
                },
                GHRC: {
                    TITLE: 'Guided HR Compliance (GHRC)',
                    DESCRIPTION:
                        'Manage complex HR challenges with confidence. Work with a dedicated HR expert who partners with you to address your unique needs and guide you toward strategic HR using our most popular Mineral solutions.',
                    BUTTON_TEXT: 'Learn More',
                    LICENSE_CODES: ['MIN - GUID - HRC'],
                    PENDO_GUIDE_ID: 'CtCaCed2_fq0K0yoyF65s9aPsW4',
                },
                LEARN_CATALOGS: {
                    TITLE: 'Learn Catalogs',
                    DESCRIPTION:
                        'Upskill and reskill your employees with Learn Course Catalogs, an expanded training catalog of business-critical courses to suit a variety of learning levels and languages.',
                    BUTTON_TEXT: 'Learn More',
                    LICENSE_CODES: [
                        'WPHP-CCU',
                        'WP SAFETY-CCU',
                        'MIN - WKPS - SAF',
                        'MIN - WKPH - USA',
                        'MIN - WKPS - 100E',
                        'MIN - WKPS - 1KE',
                        'MIN - WHP - 100E',
                        'MIN - WPHP - 1KE',
                        'MIN - DEIB - LRN',
                        'WPHP HCM-CCU',
                        'MIN - MSFT - LRN',
                        'MIN - COMM - LRN',
                        'MIN - LEAD - MGT',
                        'MIN - CYBR - SEC',
                        'MIN - WELL - HLT',
                    ],
                    PENDO_GUIDE_ID: 'mI9HpoaF-0AVLvwA3usZeHMc7R4',
                },
                ANONYMOUS_REPORTING: {
                    TITLE: 'Anonymous Reporting',
                    DESCRIPTION:
                        'Empower your employees to anonymously report workplace concerns before they become larger issues—or a liability risk. This best-practices solution helps you manage and take action on reported incidents in a secure and timely manner.',
                    BUTTON_TEXT: 'Learn More',
                    LICENSE_CODES: ['MIN - ANON - REP', 'MT - ETC - HTL'],
                    PENDO_GUIDE_ID: 'u2s-E5K0GVnCbqtK2hZYQuW9OaI',
                },
                ACA: {
                    TITLE: 'ACA Reporting',
                    DESCRIPTION:
                        'Stay compliant with IRS requirements by simplifying your annual ACA filings. Easily generate and file Forms 1094/1095-C, track status, and reduce the risk of costly penalties.',
                    BUTTON_TEXT: 'Learn More',
                    LICENSE_CODES: ['MIN - ACA - REP'],
                    PENDO_GUIDE_ID: 'pjjxqlijSZ7bEVLTFpt6zw5z-08',
                    INFO_TEXT:
                        'Only users with the "This is an ACA Admin" setting on their profile can access the ACA Reporting Hub.',
                },
            },
            ADDITIONAL: {
                TITLE: 'Additional Mitratech Solutions',
                DESCRIPTION:
                    'Designed to make day-to-day tasks simple and compliant, Mitratech’s trusted HR solutions provide teams with easy-to-use tools to help manage the entire employee lifecycle.',
                EMPTY_PRODUCT_BANNER: 'There are no Mitratech solutions to purchase at this time.',
                ASSURE_HIRE: {
                    TITLE: 'Background Screening',
                    DESCRIPTION:
                        'Unlock success with comprehensive talent management software to help you source, onboard, and retain top talent.',
                    PRIMARY_BUTTON_TEXT: 'Learn More',
                    SECONDARY_BUTTON_TEXT: 'Use Now',
                    LICENSE_CODES: ['MT - ASSURE - HIRE'],
                    LEADS_INFO: {
                        AD_TYPE: 'LearnMore',
                        OPTY_NAME: 'AssureHire',
                        PENDO_ID: '',
                        SOURCE: 'Solution_Shop',
                    },
                    PENDO_GUIDE_ID: 'UR7aSAiFSGCJ2E11MzEghmm0S1s',
                    SKU_KEYS: ['assurehire'],
                    USE_NOW_LINK: 'https://assurehire.com/signin',
                },
                TRAKSTAR_PERFORM: {
                    TITLE: 'Performance Management',
                    DESCRIPTION:
                        'Boost performance with real-time insights and smarter, data-driven decisions. Discover how streamlined reviews can benefit your business.',
                    PRIMARY_BUTTON_TEXT: 'Learn More',
                    SECONDARY_BUTTON_TEXT: 'Use Now',
                    LICENSE_CODES: ['MT - TRAK - STAR'],
                    LEADS_INFO: {
                        AD_TYPE: 'LearnMore',
                        OPTY_NAME: 'Trakstar_Perform',
                        PENDO_ID: '',
                        SOURCE: 'Solution_Shop',
                    },
                    PENDO_GUIDE_ID: 'JAntzo3adAU9wYnbogjW8yXDMFs',
                    MIN_EMPLOYEE_COUNT: 50,
                    EMPLOYEE_COUNT: {
                        MIN_LIMIT: 50,
                    },
                    SKU_KEYS: ['trakstar-perform'],
                    USE_NOW_LINK: 'https://perform.trakstar.com/',
                },
                TRACKER_I9: {
                    TITLE: 'I-9 Compliance',
                    DESCRIPTION:
                        "Enable smarter, faster, and more reliable I-9 management and compliance with the only end-to-end software solution that's maintained a perfect 20-year track record with U.S. government agencies.",
                    PRIMARY_BUTTON_TEXT: 'Learn More',
                    SECONDARY_BUTTON_TEXT: 'Use Now',
                    LICENSE_CODES: ['MT - TRACK - I9'],
                    LEADS_INFO: {
                        AD_TYPE: 'LearnMore',
                        OPTY_NAME: 'Tracker_I9',
                        PENDO_ID: '',
                        SOURCE: 'Solution_Shop',
                    },
                    PENDO_GUIDE_ID: 'fyzFkRPZJwomzUCOhTbte6ne-fU',
                    MIN_EMPLOYEE_COUNT: 1000,
                    EMPLOYEE_COUNT: {
                        MIN_LIMIT: 1000,
                    },
                    SKU_KEYS: ['tracker-i-9'],
                    USE_NOW_LINK:
                        'https://sts.i9complete.com/?ReturnUrl=https%3A%2F%2Fwww.i9complete.com%2F',
                },
                ETHICS_HOTLINE: {
                    TITLE: 'Ethics Hotline',
                    DESCRIPTION:
                        'Strengthen organizational accountability and trust with a secure, anonymous reporting solution. Empower employees to speak up safely, streamline incident management, and mitigate compliance and reputational risk.',
                    PRIMARY_BUTTON_TEXT: 'Learn More',
                    SECONDARY_BUTTON_TEXT: 'Use Now',
                    LICENSE_CODES: ['MIN - ANON - REP', 'MT - ETC - HTL'],
                    LEADS_INFO: {
                        AD_TYPE: 'LearnMore',
                        OPTY_NAME: 'Mitratech Ethics Hotline',
                        PENDO_ID: '',
                        SOURCE: 'Solution_Shop',
                    },
                    PENDO_GUIDE_ID: '3k6-565QEzvxsDTKfbV5TaLFQ8U',
                    SKU_KEYS: ['ethics_hotline'],
                    USE_NOW_LINK: '',
                    INFO_TEXT:
                        'Only users with the Client AR Admin role can access the Ethics Hotline and manage submitted reports.',
                },
                LEAVE: {
                    TITLE: 'Leave',
                    DESCRIPTION:
                        'Leave helps HR teams quickly determine employee eligibility and entitlements across federal, state, local, and company policies. Using a deterministic rules engine with guided AI assistance, the platform generates clear, explainable leave recommendations and audit-ready documentation, so HR can handle complex leave requests with confidence and stay compliant.',
                    PRIMARY_BUTTON_TEXT: 'Learn More',
                    SECONDARY_BUTTON_TEXT: 'Use Now',
                    // TODO - Need to change License code when we have the correct one for Leave product
                    LICENSE_CODES: ['MIN - LIC - TEST'],
                    LEADS_INFO: {
                        AD_TYPE: 'LearnMore',
                        OPTY_NAME: 'Leave',
                        PENDO_ID: '',
                        SOURCE: 'Solution_Shop',
                    },
                    PENDO_GUIDE_ID: 'KYMmnaUqCpr3oGNSSwekVyFowVs',
                    SKU_KEYS: ['leave'],
                    // TODO - Need to change USE NOW url when we have the correct one for Leave product
                    USE_NOW_LINK: 'https://mitratech.com/',
                },
                TYPES: {
                    ASSURE_HIRE: 'ASSURE_HIRE',
                    TRAKSTAR_PERFORM: 'TRAKSTAR_PERFORM',
                    TRACKER_I9: 'TRACKER_I9',
                    ETHICS_HOTLINE: 'ETHICS_HOTLINE',
                    LEAVE: 'LEAVE',
                },
            },
        },
        HELP_CENTER: {
            TITLE: 'Help Center',
        },
        PRODUCT_LIST: {
            TITLE: 'Purchased Products',
            BUTTONS: {
                USE_NOW: 'Use Now',
            },
        },
    },
};
